<template>
	<div class="mini-shop-page">
		<div class="page-head">
			<div class="tab-bar">
				<button
					v-for="item in tabs"
					:key="item.name"
					type="button"
					class="tab-btn"
					:class="{ 'is-active': tab === item.name }"
					@click="switchTab(item.name)"
				>{{ item.label }}</button>
			</div>
			<div class="summary-bar">
				<span>待审核总额 {{ summary.pending_yuan || '-' }}</span>
				<span>已打款总额 {{ summary.paid_yuan || '-' }}</span>
			</div>
			<el-form :inline="true" size="small" class="filter-form" @submit.native.prevent="onRefresh">
				<el-form-item>
					<el-button type="primary" :loading="loading" @click="onRefresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div class="table-wrap">
			<el-table :data="list" size="small" height="100%" v-loading="loading" class="shop-table">
				<el-table-column label="分销员" min-width="180">
					<template slot-scope="scope">
						<div class="member-cell">
							<div class="member-name">{{ scope.row.nickname || '未知' }}</div>
							<div class="sub">{{ scope.row.mobile || '-' }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="提现金额" width="120" align="center">
					<template slot-scope="scope">{{ scope.row.amount_yuan || '-' }}</template>
				</el-table-column>
				<el-table-column label="待抵扣欠款" width="120" align="center">
					<template slot-scope="scope">
						<el-tooltip
							v-if="hasDebt(scope.row.debt_commission_yuan)"
							content="该分销员待抵扣欠款，提现额度已按余额减欠款校验"
							placement="top"
						>
							<span class="debt-text">{{ scope.row.debt_commission_yuan }}</span>
						</el-tooltip>
						<span v-else>{{ scope.row.debt_commission_yuan || '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="100" align="center">
					<template slot-scope="scope">{{ scope.row.status_text || '-' }}</template>
				</el-table-column>
				<el-table-column label="申请时间" width="170" align="center">
					<template slot-scope="scope">{{ scope.row.apply_time_str || '-' }}</template>
				</el-table-column>
				<el-table-column label="操作" width="180" align="center" fixed="right">
					<template slot-scope="scope">
						<template v-if="Number(scope.row.status) === 0">
							<span class="cell-link" @click="onApprove(scope.row)">通过</span>
							<span class="cell-link cell-link-gap" @click="onReject(scope.row)">拒绝</span>
						</template>
						<span
							v-else-if="Number(scope.row.status) === 1"
							class="cell-link"
							@click="onPay(scope.row)"
						>确认打款</span>
						<span v-else class="sub">-</span>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div class="pager">
			<el-pagination
				background
				layout="total, sizes, prev, pager, next"
				:total="total"
				:current-page="page"
				:page-size="limit"
				:page-sizes="pageSizes"
				@current-change="onPageChange"
				@size-change="onSizeChange"
			/>
		</div>
	</div>
</template>

<script>
	import { MINI_CONFIG_API, MINI_SHOP_PAGE_SIZES, canUseMiniprogram, getApiErrorMessage } from '@/constants/retailPlatform'

	export default {
		name: 'MiniprogramWithdraw',
		inject: ['appdata'],
		data() {
			return {
				tabs: [
					{ name: 'all', label: '全部' },
					{ name: '0', label: '待审核' },
					{ name: '1', label: '已通过' },
					{ name: '2', label: '已打款' },
					{ name: '3', label: '已拒绝' },
				],
				pageSizes: MINI_SHOP_PAGE_SIZES,
				tab: 'all',
				page: 1,
				limit: 20,
				total: 0,
				list: [],
				loading: false,
				actingId: 0,
				summary: {},
			}
		},
		mounted() {
			this.loadList()
		},
		methods: {
			hasDebt(val) {
				const num = Number(val)
				return !isNaN(num) && num > 0
			},
			guardPermission() {
				if (!canUseMiniprogram(this.appdata && this.appdata.myinfo)) {
					this.$message.warning('未开通小程序功能，请联系管理员')
					return false
				}
				return true
			},
			switchTab(name) {
				if (this.tab === name) {
					return
				}
				this.tab = name
				this.page = 1
				this.loadList()
			},
			onRefresh() {
				this.page = 1
				this.loadList()
			},
			onPageChange(page) {
				this.page = page
				this.loadList()
			},
			onSizeChange(limit) {
				this.limit = limit
				this.page = 1
				this.loadList()
			},
			loadList() {
				const payload = {
					page: this.page,
					limit: this.limit,
				}
				if (this.tab !== 'all') {
					payload.status = Number(this.tab)
				}
				this.loading = true
				this.$axios.post(MINI_CONFIG_API.withdrawList, payload).then((res) => {
					if (!res.data || res.data.code != 0) {
						this.list = []
						this.total = 0
						this.summary = {}
						this.$message.error(getApiErrorMessage(res, '获取提现列表失败'))
						return
					}
					const data = res.data.data || {}
					this.list = data.list || []
					this.total = Number(data.total) || 0
					this.summary = data.summary || {}
				}).catch((err) => {
					console.log(err)
					this.list = []
					this.total = 0
					this.summary = {}
					this.$message.error('获取提现列表失败')
				}).finally(() => {
					this.loading = false
				})
			},
			onApprove(row) {
				if (!row || !this.guardPermission() || this.actingId) {
					return
				}
				this.$confirm('确认通过该提现申请？通过后需线下转账，再点确认打款。', '审核通过', {
					type: 'warning',
					confirmButtonText: '通过',
				}).then(() => {
					this.actingId = row.id
					return this.$axios.post(MINI_CONFIG_API.withdrawApprove, { id: row.id })
				}).then((res) => {
					if (!res) {
						return
					}
					if (!res.data || res.data.code != 0) {
						this.$message.error(getApiErrorMessage(res, '审核失败'))
						return
					}
					this.$message.success('审核通过')
					this.loadList()
				}).catch((err) => {
					if (err === 'cancel' || err === 'close') {
						return
					}
					console.log(err)
					this.$message.error('审核失败')
				}).finally(() => {
					this.actingId = 0
				})
			},
			onPay(row) {
				if (!row || !this.guardPermission() || this.actingId) {
					return
				}
				this.$confirm('确认已完成线下转账？确认后状态变为已打款。', '确认打款', {
					type: 'warning',
					confirmButtonText: '已打款',
				}).then(() => {
					this.actingId = row.id
					return this.$axios.post(MINI_CONFIG_API.withdrawPay, { id: row.id })
				}).then((res) => {
					if (!res) {
						return
					}
					if (!res.data || res.data.code != 0) {
						this.$message.error(getApiErrorMessage(res, '确认打款失败'))
						return
					}
					this.$message.success('确认打款成功')
					this.loadList()
				}).catch((err) => {
					if (err === 'cancel' || err === 'close') {
						return
					}
					console.log(err)
					this.$message.error('确认打款失败')
				}).finally(() => {
					this.actingId = 0
				})
			},
			onReject(row) {
				if (!row || !this.guardPermission() || this.actingId) {
					return
				}
				this.$prompt('拒绝后金额退回分销员余额，请填写原因', '拒绝提现', {
					confirmButtonText: '拒绝',
					cancelButtonText: '取消',
					inputPlaceholder: '拒绝原因',
					inputValidator: (value) => {
						if (!value || !String(value).trim()) {
							return '请填写拒绝原因'
						}
						return true
					},
				}).then(({ value }) => {
					this.actingId = row.id
					return this.$axios.post(MINI_CONFIG_API.withdrawReject, {
						id: row.id,
						reason: String(value).trim(),
					})
				}).then((res) => {
					if (!res) {
						return
					}
					if (!res.data || res.data.code != 0) {
						this.$message.error(getApiErrorMessage(res, '拒绝失败'))
						return
					}
					this.$message.success('已拒绝，金额已退回')
					this.loadList()
				}).catch((err) => {
					if (err === 'cancel' || err === 'close') {
						return
					}
					console.log(err)
					this.$message.error('拒绝失败')
				}).finally(() => {
					this.actingId = 0
				})
			},
		},
	}
</script>

<style scoped lang="less">
	.mini-shop-page {
		height: 100%;
		display: flex;
		flex-direction: column;
		background: #fff;
		padding: 12px 16px 8px;
		box-sizing: border-box;
		overflow: hidden;
	}

	.page-head {
		flex: none;
	}

	.tab-bar {
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 12px;
	}

	.tab-btn {
		position: relative;
		display: inline-flex;
		align-items: center;
		height: 40px;
		padding: 0 16px;
		border: 0;
		background: transparent;
		color: #606266;
		font-size: 14px;
		line-height: 1;
		cursor: pointer;
		outline: none;

		&.is-active {
			color: #ff4714;
			font-weight: 500;

			&::after {
				content: '';
				position: absolute;
				left: 16px;
				right: 16px;
				bottom: 0;
				height: 2px;
				background: #ff4714;
			}
		}
	}

	.summary-bar {
		display: flex;
		flex-wrap: wrap;
		gap: 8px 16px;
		margin-bottom: 12px;
		font-size: 13px;
		color: #606266;
	}

	.filter-form {
		display: flex;
		align-items: center;
		margin-bottom: 12px;

		/deep/ .el-form-item {
			margin: 0 8px 0 0;
		}
	}

	.table-wrap {
		flex: 1;
		min-height: 0;
	}

	.shop-table {
		width: 100%;
	}

	.member-name {
		color: #303133;
		line-height: 1.4;
	}

	.sub {
		margin-top: 2px;
		font-size: 12px;
		color: #909399;
	}

	.debt-text {
		color: #f56c6c;
		font-weight: 600;
		cursor: default;
	}

	.cell-link {
		color: #ff4714;
		cursor: pointer;
		font-size: 13px;
	}

	.cell-link-gap {
		margin-left: 8px;
	}

	.pager {
		flex: none;
		padding: 10px 0 4px;
		text-align: right;
	}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/miniprogram/withdraw.vue